import { createWebHistory, createRouter } from "vue-router";

// Pages are lazy-loaded; each gets its own chunk.
const routes = [
    { path: '/', name: 'landing', component: () => import('../views/PageHome.vue'), meta: { title: 'BUCLID: clinical notes that teach' } },
    { path: '/demo', name: 'demo', component: () => import('../views/PageHome.vue'), meta: { title: 'BUCLID: clinical notes that teach' } },
    { path: '/osceval', name: 'osceval', component: () => import('../views/PageOSCEval.vue'), meta: { title: 'OSCEval: automated grading for OSCE notes · BUCLID' } },
    { path: '/maeni', name: 'maeni', component: () => import('../views/PageMAENI.vue'), meta: { title: 'MAENI®: clinical-encounter assessment · BUCLID' } },
    { path: '/about', name: 'about', component: () => import('../views/PageAbout.vue'), meta: { title: 'About BUCLID' } },
  ];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


router.afterEach((to) => {
  window.scrollTo(0, 0);
  if (to.meta.title) document.title = to.meta.title;
});


export default router;
